import { AbstractControl } from '@angular/forms';

export const enum ConfirmTypes {
	okCancel = 'okCancel',
	yesNo = 'yesNo',
}

export type ConfirmType = ConfirmTypes.okCancel | ConfirmTypes.yesNo;

export interface ConfirmDialogModel {
	title: string;
	message: string;
	type: ConfirmType;
	customConfirmCaption?: string;
	confirmIsPrimaryColor?: boolean;
}

export interface MultiButtonDialogComponentDialogModel {
	title: string;
	body: string;
	asHtml?: boolean;
	buttons: {
		label: string;
		value: string;
		primary?: boolean;
		warn?: boolean;
		shortcutKey?: string;
	}[];
}

export interface MessageDialogModel {
	title: string;
	message: string;
	closeButtonLabel: string;
	safeHtml?: boolean;
}

export class SaveChangesDialogModel {
	constructor(
		public typeName: string,
		public form?: AbstractControl,
		public overrideText?: string,
	) {}
}

export class MultipleUnsavedChangesDialogModel {
	constructor(public typeNames: string[]) {}
}

export const enum SaveChangesResult {
	Save,
	Discard,
	Cancel,
}

export interface ErrorDialogModel {
	title: string;
	message: string;
	error: object;
	devMode?: boolean;
}
